import type {SearchCriteriaRaw} from '../../../types';
import {createFileAspectRule} from '../fileAspectRule';
import type {FileAspectRule, TSearchTypeFileAspect} from '../types';

export type RawFileAspectSearchCriteria =
	SearchCriteriaRaw<TSearchTypeFileAspect>;

export const rawFileAspectCriteriaToRuleObject = (
	criteria: RawFileAspectSearchCriteria,
): FileAspectRule => {
	return createFileAspectRule({
		type: criteria.subtype1,
		subType: criteria.subtype2,
		value: parseInt(criteria.value1) || 0,
	});
};

export default rawFileAspectCriteriaToRuleObject;
